export const useInlineImages = (body: string) => {
    const regex = /<img.*?data-align="(.*?)".*?>/g;

    if (!body) return body;
    const newBody = body.replace(regex, (imgTag, align) => {
        let caption = ``;
        const captionRgx = imgTag.match(/data-caption="(.*?)"/g);

        if (captionRgx) {
            const [captionMatch] = captionRgx;

            if (captionMatch) {
                caption = captionMatch.replace(`data-caption="`, ``);
                caption = caption
                    .substring(0, caption.length - 1)
                    .replaceAll(`&lt;`, `<`)
                    .replaceAll(`&gt;`, `>`)
                    .replaceAll(`&amp;`, `&`)
                    .replaceAll(`&nbsp;`, ` `);
            }
        }
        return `<figure class="${align}">${imgTag}${
            caption ? `<figcaption>${caption}</figcaption>` : ``
        }</figure>`;
    });

    return newBody;

    /**
     * This code kind of works but since drupal doesn't expose inline-images we'll need to
     * modify the plugin or something in the future so this use case actually covers a lot of inline images.
    
    const {
        allFile: { nodes: files },
    } = useStaticQuery(graphql`
        query {
            allFile {
                nodes {
                    url
                    publicURL
                }
            }
        }
    `);

    console.log(body);

    const regex = /<img.*?src="(.*?)"/g;
    const a = body.replace(regex, (s, g) => {
        const unencoded = decodeURIComponent(g);
        const match = files.find((file) =>
            decodeURIComponent(file.url).includes(unencoded)
        );
        console.log(unencoded, match);
        if (match) {
            const o = s.replace(decodeURIComponent(g), match.publicURL);
            return o;
        }
        return g;
    });

    return body;
         */
};
